
















import { Component, Prop, Vue } from 'vue-property-decorator';
import { OrderDispatchTask, retryDispatchTask, resolveDispatchCancellation, resolveDispatchCreation } from '@/api/receipt-management/order-dispatch';
import { messageError } from '@/utils';
@Component
export default class OrderDispatchStatus extends Vue {
  @Prop({ default: false }) public changeApproving!: boolean;
  @Prop() public task?: OrderDispatchTask;
  public retrying = false;
  public get label(): string {
    if (this.task!.status === 30 && this.task!.operation === 30) return '取消成功';
    return ({ 10: '待同步', 20: '处理中', 30: '成功', 40: '失败', 50: '已取消' })[this.task!.status];
  }
  /** This confirms a checked external result; it never resends an uncertain deletion. */
  public async resolveUncertain(): Promise<void> {
    if (!this.task || this.task.resolvable !== true || this.retrying) return;
    const taskId = this.task.id;
    const isCancel = this.task.operation === 30;
    this.retrying = true;
    try {
      const result = await this.$prompt(
        isCancel
          ? '请先核查并确认：原黑湖删除请求已经结束，且该任务涉及的全部黑湖工单均已不存在。填写核查记录后确认，系统将再次检查工单是否不存在；此操作不会重新发送删除请求。'
          : '请先核查并确认：原黑湖创建请求已经结束，且已核对黑湖工单状态。请记录已存在和不存在的工单及核查依据。系统将再次查询工单状态，仅恢复剩余同步；已取消订单将继续取消处理。',
        isCancel ? '核查后确认取消' : '核查后恢复同步',
        {
          type: 'warning',
          confirmButtonText: isCancel ? '已核查无误，确认取消' : '已核查无误，恢复同步',
          cancelButtonText: '暂不处理',
          inputType: 'textarea',
          inputPlaceholder: '填写核查方式、结果及相关记录（必填）',
          closeOnClickModal: false,
          inputValidator: (value: string): boolean | string => {
            if (!value || !value.trim()) return '请填写核查记录';
            if (value.trim().length > 1000) return '核查记录最多 1000 字';
            return true;
          }
        }
      );
      const note = (result as { value: string }).value.trim();
      if (isCancel) await resolveDispatchCancellation(taskId, note);
      else await resolveDispatchCreation(taskId, note);
      this.$message.success(isCancel ? '已核查并确认取消' : '已核查并提交后台处理');
      this.$emit('refresh');
    } catch (error) {
      if (error !== 'cancel' && error !== 'close') messageError(error as any);
    } finally { this.retrying = false; }
  }
  public async retry(): Promise<void> {
    if (!this.task || this.retrying) return;
    this.retrying = true;
    try {
      await retryDispatchTask(this.task.id);
      this.$message.success('已提交后台同步');
      this.$emit('refresh');
    } catch (error) { messageError(error as any); }
    finally { this.retrying = false; }
  }
}
